export default __webpack_public_path__ + "static/media/cart-copy.585343ec.svg";